import { mapOptionsFromOrganizations } from "../utils";
import useChildOrganizations from "./useChildOrganizations";
/*
  This hook only gets the child organizations if the use is authorized to see them (e.g. Company Admin).
*/
var useChildOrganizationsList = function useChildOrganizationsList(_ref) {
  var corporationName = _ref.corporationName,
    corporationSlug = _ref.corporationSlug,
    currentSlug = _ref.currentSlug,
    skip = _ref.skip;
  var _useChildOrganization = useChildOrganizations({
      slug: corporationSlug,
      searchKey: '',
      skip: skip
    }),
    organizations = _useChildOrganization.organizations;
  var organizationsList = mapOptionsFromOrganizations({
    organizations: organizations,
    corporationSlug: corporationSlug,
    corporationName: corporationName
  });
  var defaultSelectedOrganization = organizationsList.find(function (el) {
    return el.value === currentSlug;
  });
  return {
    organizationsList: organizationsList,
    defaultSelectedOrganization: defaultSelectedOrganization
  };
};
export default useChildOrganizationsList;